import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, fmtDate } from "../lib/api";
import { ShieldCheck, ShieldX, Loader2, GraduationCap } from "lucide-react";

export default function VerifyCertificate() {
  const { code } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/lms/verify/${code}`).then(({ data }) => setData(data)).catch(() => setData({ valid: false }));
  }, [code]);

  if (!data) return <div className="flex min-h-[60vh] items-center justify-center"><Loader2 className="animate-spin text-[#0E7C7B]" size={28} /></div>;

  return (
    <div className="mx-auto flex min-h-[70vh] max-w-xl items-center px-4 py-16" data-testid="verify-certificate-page">
      <div className="w-full rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
        <p className="flex items-center justify-center gap-2 text-center font-mono text-xs uppercase tracking-widest text-[#0E7C7B]">
          <GraduationCap size={15} /> Cabinet CARIS Santé — Vérification
        </p>
        {data.valid ? (
          <div className="mt-6 text-center" data-testid="verify-valid">
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-emerald-100"><ShieldCheck size={34} className="text-emerald-600" /></div>
            <h1 className="mt-4 font-display text-2xl font-bold text-navy">Certificat authentique</h1>
            <p className="mt-1 text-sm text-slate-500">Ce certificat a bien été délivré par le Cabinet CARIS Santé.</p>
            <div className="mt-6 space-y-3 rounded-2xl bg-slate-50 p-5 text-left text-sm">
              <div className="flex justify-between gap-4"><span className="text-slate-400">Titulaire</span><span className="font-semibold text-navy" data-testid="verify-name">{data.name}</span></div>
              <div className="flex justify-between gap-4"><span className="text-slate-400">Formation</span><span className="text-right font-semibold text-navy">{data.course_title}</span></div>
              {data.instructor && <div className="flex justify-between gap-4"><span className="text-slate-400">Formateur</span><span className="font-semibold text-navy">{data.instructor}</span></div>}
              <div className="flex justify-between gap-4"><span className="text-slate-400">Type</span><span className="font-semibold text-navy">{data.kind === "quiz" ? "Réussite (évaluation)" : "Participation"}</span></div>
              {data.score != null && <div className="flex justify-between gap-4"><span className="text-slate-400">Score</span><span className="font-semibold text-[#0E7C7B]">{data.score}%</span></div>}
              {data.issued_at && <div className="flex justify-between gap-4"><span className="text-slate-400">Délivré le</span><span className="font-semibold text-navy">{fmtDate(data.issued_at)}</span></div>}
            </div>
          </div>
        ) : (
          <div className="mt-6 text-center" data-testid="verify-invalid">
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-red-100"><ShieldX size={34} className="text-red-600" /></div>
            <h1 className="mt-4 font-display text-2xl font-bold text-navy">Certificat introuvable</h1>
            <p className="mt-1 text-sm text-slate-500">Aucun certificat ne correspond au code « {code} ». Vérifiez le code ou scannez à nouveau le QR.</p>
          </div>
        )}
      </div>
    </div>
  );
}
